import type { IconDefinition } from '../index.tsx';

export const iconChevronRight: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconChevronRight',
  icon: [
    16,
    16,
    [],
    '',
    'M8.17151 8.00015L3.58573 3.41436L6.41416 0.585938L13.8284 8.00015L6.41416 15.4144L3.58573 12.5859L8.17151 8.00015Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
